<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="getTitle" class="common-header" style="box-shadow: none;">
        <mt-button slot="left" icon="back" @click="goBack"></mt-button>
        <mt-button v-if="!isAddMode" style="color: #E7010C;font-weight: 600; padding-right:15px;" slot="right"
          @click="onDelete(address_id)">
          {{ $t('Delete') }}
        </mt-button>
      </mt-header>
    </div>
    <div class="main-content">
      <!-- 国家/地区标题 -->
      <div class="title-line" style="padding-top:15px;">{{ $t("Country/Region") }}</div>
      <!-- 国家/地区选择框 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" style="cursor: pointer;" slot="right">
          <v-select
            v-model="selectedCountry"
            :options="countries"
            label="name"
            :reduce="country => country"
            searchable
            :filterBy="filterCountries"
            :clearable="false"
            aria-readonly="true"
            style="width: 16.3rem;cursor:pointer;border:unset;"
          >
            <template #option="{ name, flag_code }">
              <div class="country-option">
                <span :class="['country-flag', flag_code]"></span>
                {{ name }}
              </div>
            </template>
            <template #selected-option="{ name, flag_code }">
              <div class="selected-country">
                <span :class="['country-flag', flag_code]"></span>
                {{ name }}
              </div>
            </template>
          </v-select>
        </div>
      </flex-line>

      <!-- 联系信息标题 -->
      <div class="title-line">{{ $t("Contact info") }}</div>
      <!-- 收货人姓名输入框 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter real name')" v-model="address_info.address_realname" />
        </div>
      </flex-line>

      <!-- 联系方式 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right" style="display: flex; align-items: center;">
          <!-- 国家区号 -->
          <input class="field-input" style="flex: none;width: 42px;border-right:1px solid #ccc;" readonly v-model="address_info.country_code" />
          <!-- 手机号 -->
          <input class="field-input" style="width: 10.5rem;" :placeholder="$t('Please enter Phone Number')" v-model="address_info.address_mob_phone" />
        </div>
      </flex-line>

      <!-- 地址标题 -->
      <div class="title-line">{{ $t("address") }}</div>
      <!-- 州/省/地区输入框 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter State/Province/Region')" v-model="address_info.state" />
        </div>
      </flex-line>
      <!-- 城市输入框 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter City')" v-model="address_info.city" />
        </div>
      </flex-line>
      <!-- 街道地址输入框 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter Street Address')" v-model="address_info.street" />
        </div>
      </flex-line>
      <!-- 邮政编码输入框 -->
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" style="width: 8rem;" maxlength="10" :placeholder="$t('Please enter Postal Code')" v-model="address_info.postal_code" />
        </div>
      </flex-line>

      <!-- 是否设为默认地址 -->
      <flex-line :show-border="true" style="width: 93%;">
        <span class="line-name">{{ $t("default address") }}</span>
        <div slot="right">
          <mt-switch v-model="address_info.address_is_default"></mt-switch>
        </div>
      </flex-line>

      <!-- 提交按钮 -->
      <div class="pt-10 pb-10">
        <div class="common-btn ds-button-large" @click="submit">
          {{ getSumitTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../assets/style/country.scss';
import { mapState, mapActions } from "vuex";
import { Toast, Indicator, MessageBox } from "mint-ui";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { getAddressInfo, addAddressNew, delAddress, editAddressNew } from "../../../api/memberAddress";
import flexLine from "../../flexLine";
import { getArea } from '../../../api/area'; // 假设有一个 API 可以获取国家信息

export default {
  components: {
    flexLine,
    'v-select': vSelect
  },
  data() {
    return {
      address_id: this.$route.query.address_id || 0,
      goBackLevel: this.$route.query.goBackLevel || -1,
      address_info: {
        area_id: 108,
        address_realname: "",
        country: "",
        country_code: "",
        address_mob_phone: "",
        state: "",
        city: "",
        street: "",
        postal_code: "",
        address_is_default: true
      },
      selectedCountry: null,
      countries: []
    };
  },
  created() {
    // this.fetchConfig()
    this.loadCountries()
    if (!this.isAddMode) {
      this.fetchAddressInfo()
    }
  },
  computed: {
    ...mapState({
      config: (state) => state.config.config,
    }),
    isAddMode() {
      return this.$route.query.action === "add";
    },
    getTitle() {
      return this.isAddMode ? this.$t("Add address") : this.$t("Edit address");
    },
    getSumitTitle() {
      return this.$route.query.isFromCheckout ? this.$t("save and use") : this.$t("save");
    },
  },
  watch: {
    selectedCountry(newCountry) {
      if (newCountry) {
        this.address_info.area_id = newCountry.area_id;
        this.address_info.country = newCountry.name;
        this.address_info.country_code = newCountry.code;
        this.address_info.country_flag_code = newCountry.flag_code;
      }
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: "fetchConfig",
    }),
    fetchAddressInfo() {
      let that = this
      getAddressInfo(this.address_id)
        .then((res) => {
          let info = res.result.address_info
          that.address_info.address_realname = info.address_realname
          that.address_info.address_mob_phone = info.address_mob_phone
          that.address_info.state = info.state
          that.address_info.city = info.city
          that.address_info.street = info.street
          that.address_info.postal_code = info.postal_code
          that.address_info.address_is_default = info.address_is_default == "1" ? true:false
          if(!this.isAddMode){
            const country = that.countries.find(country => country.area_id === info.area_id)
            that.selectedCountry = country
            that.address_info.area_id = info.area_id
            that.address_info.country = info.country
            that.address_info.country_code = info.country_code
            that.address_info.country_flag_code = info.country_flag_code
          }
        })
        .catch((error) => Toast(error.message));
    },
    loadCountries() {
      let that = this;
      getArea().then(res => {
        that.countries = res.result.area_list.map(country => ({
          ...country,
          flag_code: country.flag_code
        }));
        const india = that.countries.find(country => country.name === "India");
        if (india) {
          that.selectedCountry = india;
          that.address_info.country = india.name;
          that.address_info.country_code = india.code;
        }
      }).catch(error => {
        Toast(error.message);
      });
    },
    filterCountries(option, label, search) {
      return label.toLowerCase().includes(search.toLowerCase());
    },
    onDelete(addressId) {
      MessageBox.confirm(this.$t("MessageBox.delete.address"), {
        title: this.$t("MessageBox.Tips"),
        confirmButtonText: this.$t("MessageBox.Confirm"),
        cancelButtonText: this.$t("MessageBox.Cancel"),
      }).then(() => {
        Indicator.open();
        delAddress(addressId)
          .then(() => this.goBack())
          .catch((error) => Toast(error.message))
          .finally(() => Indicator.close());
      });
    },
    goBack() {
      this.$router.go(this.goBackLevel);
    },
    submit() {
      if (!this.validateAddressInfo()) return;

      const action = this.isAddMode ? addAddressNew : editAddressNew;
      Indicator.open();
      this.address_info.area_info = this.address_info.country + " " + this.address_info.state + " " + this.address_info.city
      this.address_info.address_detail = this.address_info.street
      action(this.address_info, this.address_id)
        .then(() => {
          Toast(this.$t('succ'))
          setTimeout(() => {
            this.goBack()
          }, 1500);
        })
        .catch((error) => Toast(error.message))
        .finally(() => Indicator.close());
    },
    validateAddressInfo() {
      const { address_realname, address_mob_phone, state, city, street, postal_code } = this.address_info;
      if (!address_realname || address_realname.length < 2 || address_realname.length > 15) {
        Toast(this.$t("Name must be 2-15 characters"));
        return false;
      }
      if (!address_mob_phone) {
        Toast(this.$t("Please fill in the phone number"));
        return false;
      }
      if (!state || !city || !street || !postal_code) {
        Toast(this.$t("Please fill in all address fields"));
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.title-line{font-size: 16px;}
.ds-button-large {
  width: 250px;
  margin: auto;
  background: #E7010C;
}

.container {
  background: #fff;
}

.main-content {
  width: 400px;
  margin: auto;
  background: #fff;
  padding: 0 $pageSpace;

  .input-wrapper {
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    background-color: #fafafa;
    padding-left: 0.5rem;

    flex-direction: column;
    align-items: flex-start;
    margin: .6rem 0;

    ::v-deep(.right) {
      background: #FAFAFA;
    }

    .field-name {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      margin: .5rem 0;
    }

    input {
      flex: 1;
      font-size: $subFontSize;
      flex: 1;
      width: 14.5rem;
      text-align: left !important;
      padding: .9rem;
      background: #FAFAFA;
    }

    .bottom-input {
      border-bottom-width: 0;
    }
  }

}

.right-arrow {
  transform: rotate(-90deg);
  color: #ddd;
  font-size: $fontSize;
  display: inline-block;
}

.input-wrap {
  position: relative;

  i {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 2.4rem;
    display: block;
    width: 2rem;
    text-align: center;
    font-size: $h1
  }
}

.notice {
  font-size: $subFontSize;
  padding: .5rem;
  background: #FCF8E3;
  color: #C09853;
  line-height: 1.65rem;

  .red {
    color: #F00
  }

  .btn {
    float: right
  }
}

::v-deep(.mint-switch-core) {
  border-color: #E7010C !important;
  background-color: #E7010C !important;
}
</style>